import { gql } from '@apollo/client';
import classNames from 'classnames';
import React from 'react';
import SVGIcon from '../components/SVGIcon';
import TextWithIcon from '../components/TextWithIcon';
import type { PostTitleWithIcons_PostFragment } from '../graphql/generated/graphqlTypes';
import publicIcon from '../icons/public.svg';
import { UserRole } from '../topic/topicPolicyCheck';
import {
  isAllowedThroughLinkAccess,
  PostPolicyAction,
} from './postPolicyCheck';
import styles from './PostTitleWithIcons.module.scss';
import VerifiedIcon from './VerifiedIcon';

const POST_FRAGMENT = gql`
  fragment PostTitleWithIcons_post on RootPostFields {
    id
    title
    linkAccess
    ...isAllowedThroughLinkAccess_post
    ... on SlimPostFields {
      verifiedAt
    }
  }
  ${isAllowedThroughLinkAccess.fragments.post}
`;

interface PostTitleWithIconsProps {
  iconSize?: 'small' | 'regular';
  post: PostTitleWithIcons_PostFragment;
  title?: React.ReactNode;
  truncate?: 'single' | 'multi';
  showVerifiedIcon?: boolean;
  publicIconMuted?: boolean;
}

const PostTitleWithIcons = ({
  iconSize = 'regular',
  post,
  title,
  truncate,
  showVerifiedIcon = true,
  publicIconMuted = false,
}: PostTitleWithIconsProps) => (
  <TextWithIcon
    text={title || post.title}
    icon={
      <>
        {showVerifiedIcon && 'verifiedAt' in post && post.verifiedAt && (
          <span className={classNames(styles.icon, styles[iconSize])}>
            <VerifiedIcon inline size={iconSize} />
          </span>
        )}
        {isAllowedThroughLinkAccess(
          PostPolicyAction.ViewPost,
          post,
          UserRole.Anonymous,
        ) && (
          <span
            className={classNames(styles.icon, styles[iconSize], {
              [styles.muted]: publicIconMuted,
            })}
          >
            <SVGIcon size={iconSize} inline>
              {publicIcon}
            </SVGIcon>
          </span>
        )}
      </>
    }
    iconPosition="end"
    truncate={truncate}
  />
);

PostTitleWithIcons.fragments = {
  post: POST_FRAGMENT,
};

export default PostTitleWithIcons;
